import { Stack } from "@mui/material";
import { useEffect } from "react";
import { useLoaderData } from "react-router-dom";

import PaginationControlsV2 from "../../../global/PaginationControlsV2";
import useEntityUsersData from "../hooks/useEntityUsersData";
import { useEntityUsersStore } from "../store/entityUsersStore";

import EntityUsersTable from "./EntityUsersTable";

export default function EntityUsers() {
  const { id: entityId } = useLoaderData();
  const { reset, data, loading, resultCount, currentPage, resLimit, setCurrentPage } =
    useEntityUsersStore();
  useEntityUsersData(entityId);

  useEffect(() => reset, [reset]);

  return (
    <div className="flex h-full flex-col gap-4">
      <div className="relative flex flex-1 flex-col gap-2 overflow-y-auto">
        <EntityUsersTable data={data} isLoading={loading} />
      </div>
      {resultCount > resLimit && (
        <div className="relative flex w-full justify-center">
          <Stack alignItems="center">
            <PaginationControlsV2
              currentPage={currentPage}
              handleChange={(_event, page) => setCurrentPage(page)}
              resultCount={resultCount}
              resultLimit={resLimit}
            />
          </Stack>
        </div>
      )}
    </div>
  );
}
